import React, { Fragment, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'

import styles from './EditKB.module.css'

import FormControl from 'Design/components/FormControl'
import Label from 'Design/components/Label'
import Input from 'Design/components/Input'
import Button from 'Design/components/Button'
import ConfirmationModal from 'Design/components/ConfirmationModal'

import SlideOverModal from 'Layout/SlideOverModal'

import { useDeleteKBMutation, useGetKbSectionsQuery, useUpdateKbMutation } from '../kb.service'
import IngoredSectionsEditor from './IgnoredSectionEditor'

const EditKB = (props) => {
  const { hide, id, name, ignoredSections = [] } = props
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const { register, control, formState, handleSubmit } = useForm({
    defaultValues: {
      name,
      ignoredSections: ignoredSections.map((section) => section.id)
    }
  })

  const { data: sections, isLoading: isSectionsLoading, isFetching: isSectionsFetching } = useGetKbSectionsQuery(id)
  const [updateKb, updateKbResult] = useUpdateKbMutation()
  const [deleteKb, deleteKbResult] = useDeleteKBMutation()

  const handleFormSubmit = (data) => {
    updateKb({
      id,
      name: data.name,
      ignore_sections: data.ignoredSections
    })
  }

  const handleDeleteClick = async () => {
    const promise = deleteKb(id).unwrap()

    toast.promise(promise, {
      loading: 'KB Deletion in progress',
      success: 'KB deleted successfully',
      error: 'Unable to delete KB. Try again...'
    })

    promise.then(handleCloseDeleteModal)
  }

  const handleOpenDeleteModal = () => {
    setShowDeleteModal(true)
  }

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false)
  }

  const isApiProgress = isSectionsLoading || isSectionsFetching || updateKbResult.isLoading || deleteKbResult.isLoading

  const disableSaveButton = !formState.isDirty || isApiProgress
  const disableDeleteButton = isApiProgress

  return (
    <Fragment>
      <ConfirmationModal
        isOpen={showDeleteModal}
        title='Delete Knowledge Base'
        onCloseButtonClick={handleCloseDeleteModal}
        onConfirmButtonClick={handleDeleteClick}
        confirmButtonText='Yes'
        cancelButtonText='No'
        disableConfirmButton={isApiProgress}
      >
        Are you sure you want to delete the Knowledge Base <strong>{name}</strong>?
      </ConfirmationModal>
      <SlideOverModal title='Edit Knowledge Base' onHide={hide}>
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <FormControl>
            <Label>Name</Label>
            <Input placeholder='Article name' {...register('name')} />
          </FormControl>
          <FormControl>
            <Label>Ignored Sections</Label>
            <Controller
              name='ignoredSections'
              control={control}
              render={({ field }) => {
                const { value, onChange } = field

                return (
                  <IngoredSectionsEditor
                    sections={sections}
                    value={value}
                    onChange={onChange}
                    isLoading={isSectionsLoading}
                  />
                )
              }}
            />
          </FormControl>
          <div className={styles.Footer}>
            <Button type='submit' variant='primary' disabled={disableSaveButton}>
              Save
            </Button>
            <Button type='button' variant='link-muted' onClick={hide}>
              Cancel
            </Button>
            <Button
              type='button'
              variant='link-danger'
              className={styles.DeleteButton}
              disabled={disableDeleteButton}
              onClick={handleOpenDeleteModal}
            >
              Delete
            </Button>
          </div>
        </form>
      </SlideOverModal>
    </Fragment>
  )
}

export default EditKB
